
// export const baseURL = 'http://192.168.1.102:9001'        // 本地 这个是志哥的本地的
// export const baseURL = 'http://47.120.18.3:9001'
export const baseURL = 'https://show.nspoint.cn/eduApi'
// export const baseURL = 'http://127.0.0.1:9001'
// 文档转换时的参数前缀地址, 全局都找不到uploadFile在哪里定义的，后补by zhangzhi on 20240912
export const uploadFile = `https://show.nspoint.cn/`     // 生产机
